export default "__VITE_ASSET__BOO4o_UO__"